import { matchPath } from 'react-router-dom';

import { ENABLED_WEEKEND_DISCHARGE_HOSPITALS } from '@/constant';
import { getFirstAvailableMenuPath } from '@/menu-items';
import type { User } from '@/types/auth';
import { NO_ACCESS_PATH } from '@/utils/role';

const STAFF_DASHBOARD_PATH = '/dashboard';
const ADMIN_DASHBOARD_PATH = '/admin/hospitals/:hospitalId/dashboard';

export const isHandoffDashboardPath = (pathname: string): boolean =>
    pathname === STAFF_DASHBOARD_PATH || Boolean(matchPath({ path: ADMIN_DASHBOARD_PATH, end: true }, pathname));

/** Where to go when the selected hospital cannot stay on the handoff dashboard. Null means stay. */
export const getHandoffDashboardExitPath = ({
    pathname,
    hospitalId,
    hospitalName,
    user,
    permissions
}: {
    pathname: string;
    hospitalId: string;
    hospitalName: string;
    user: User | null | undefined;
    permissions: readonly string[];
}): string | null => {
    if (!isHandoffDashboardPath(pathname)) {
        return null;
    }

    const normalizedName = hospitalName.trim().toLowerCase();
    if (!normalizedName || ENABLED_WEEKEND_DISCHARGE_HOSPITALS.includes(normalizedName)) {
        return null;
    }

    const onAdminDashboard = Boolean(matchPath({ path: ADMIN_DASHBOARD_PATH, end: true }, pathname));

    return (
        getFirstAvailableMenuPath({
            hospitalId: onAdminDashboard ? hospitalId : undefined,
            hospitalName: normalizedName,
            user,
            permissions
        }) ?? NO_ACCESS_PATH
    );
};
